import { AfterViewInit, Directive, ElementRef, Input, OnChanges, OnDestroy, SimpleChanges } from '@angular/core';
import { asyncScheduler, Subscription } from 'rxjs';

@Directive({ selector: '[appFittext]' })
export class FittextDirective implements AfterViewInit, OnChanges, OnDestroy {
  @Input('appFittext') watchValue: any;
  @Input() minFontSize: number = 14;
  @Input() maxFontSize: number = 40;

  private viewInitialized = false;
  private fitSchedule: Subscription;

  constructor(private el: ElementRef<HTMLElement>) {}

  ngAfterViewInit(): void {
    this.viewInitialized = true;
    this.scheduleFit();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.viewInitialized && changes['watchValue']) {
      this.scheduleFit();
    }
  }

  ngOnDestroy(): void {
    if (this.fitSchedule) { this.fitSchedule.unsubscribe(); }
  }

  private scheduleFit(): void {
    if (this.fitSchedule) { this.fitSchedule.unsubscribe(); }
    this.fitSchedule = asyncScheduler.schedule(() => this.fit());
  }

  private fit(): void {
    const el = this.el.nativeElement;
    const containerWidth = el.parentElement ? el.parentElement.offsetWidth : 0;
    if (!containerWidth) { return; }
    let fontSize = this.maxFontSize;
    el.style.fontSize = fontSize + 'px';
    while (el.scrollWidth > containerWidth && fontSize > this.minFontSize) {
      fontSize--;
      el.style.fontSize = fontSize + 'px';
    }
  }
}
